/*
 * useTheme — gobierna el tema claro/oscuro de Otera.
 *
 * El tema se resuelve antes del primer paint por el script inline de
 * index.html (evita flash); este composable lo expone reactivamente y
 * permite alternarlo en runtime, persistiendo la preferencia.
 *
 * Estado a nivel de módulo (singleton): cualquier componente que llame a
 * useTheme() comparte la misma referencia, así el toggle del AppShell y
 * cualquier otro consumidor permanecen sincronizados.
 */

import { ref } from 'vue';

const STORAGE_KEY = 'otera-theme';
const VALID = ['light', 'dark'];

function readInitial() {
  // El <html> ya tiene data-theme aplicado por el script de index.html.
  const attr = document.documentElement.getAttribute('data-theme');
  if (VALID.includes(attr)) return attr;
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (VALID.includes(saved)) return saved;
  } catch {
    /* localStorage no disponible — se ignora */
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

const theme = ref(readInitial());

function apply(next) {
  theme.value = next;
  document.documentElement.setAttribute('data-theme', next);
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* localStorage no disponible — se ignora */
  }
}

export function useTheme() {
  function setTheme(next) {
    if (VALID.includes(next)) apply(next);
  }
  function toggleTheme() {
    apply(theme.value === 'dark' ? 'light' : 'dark');
  }
  return { theme, setTheme, toggleTheme };
}
